import { Icon } from "@blueprintjs/core";
import { Link, useParams } from "react-router";

import downArrow from "@/../../hypetrain/static/img/c-arrow-down-color.svg";
import upArrow from "@/../../hypetrain/static/img/c-arrow-up-color.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { Box, Flex } from "@/components/layout/flexbox";
import { buildScenarioUrl } from "@/components/pages_logged_in/roleplays/utils";
import { FlexibleButton } from "@/components/pieces/button/FlexibleButton";
import { CardAboveXs } from "@/components/pieces/CardAboveXs";
import { AvatarWithPrettyNull } from "@/components/pieces/users/AvatarWithPrettyNull";
import { getUser } from "@/components/session/JwtTokenManager";
import { CARD_CLASSES } from "@/css/constants";
import { FullRoleplaySession } from "@/types/roleplays";

function ShortExplanation({
  duration,
  minDuration = 90,
}: {
  duration: number;
  minDuration?: number;
}) {
  if (duration < minDuration) {
    return (
      <Box fontSize={16} fontWeight={400}>
        Have a longer conversation to unlock insights
      </Box>
    );
  }

  return (
    <Box fontSize={16} fontWeight={400}>
      Your conversation does not align with the scenario objectives. Try again
      to unlock insights
    </Box>
  );
}

interface RoleplaySessionInvalidAttemptMessageBoxProps {
  roleplaySession: FullRoleplaySession;
}

export function RoleplaySessionInvalidAttemptMessageBox({
  roleplaySession,
}: RoleplaySessionInvalidAttemptMessageBoxProps) {
  const user = getUser();
  const { scenario, duration } = roleplaySession;
  const isSessionOwner = roleplaySession.user?.id === user?.id;
  const roleplaySlug = useParams<{
    roleplaySlug?: string;
  }>()?.roleplaySlug;

  return (
    <CardAboveXs mt={24}>
      <Flex
        flexDirection="column"
        backgroundColor="#FFF"
        p={24}
        className={`${CARD_CLASSES}`}
        alignItems="center"
      >
        <Flex
          p={24}
          width="100%"
          maxWidth="100%"
          textAlign="center"
          backgroundColor="#FFF"
          alignItems="center"
          flexDirection="column"
        >
          <Flex flexDirection="row" alignItems="center">
            <EmbedSvg
              src={downArrow}
              width={50}
              style={{
                paddingRight: 8,
              }}
            />
            <AvatarWithPrettyNull
              user={{
                name: scenario?.personaName,
                photo: scenario?.personaPhotoUrl,
              }}
              size={90}
            />
            <EmbedSvg
              src={upArrow}
              width={45}
              style={{
                paddingLeft: 8,
              }}
            />
          </Flex>
          <Flex
            mt={-3}
            alignItems="center"
            backgroundColor="#F4F1FF"
            color="#6466EB"
            px={2}
            style={{
              borderRadius: 100,
            }}
          >
            <Icon size={14} icon="flame" />
            <Box fontWeight={600} ml={2}>
              {scenario?.personaName}
            </Box>
          </Flex>
        </Flex>
        <Box fontSize={20} fontWeight={700}>
          Retry Session to Unlock Insights
        </Box>

        <ShortExplanation
          duration={duration || 0}
          minDuration={scenario?.minDuration || 90}
        />

        {isSessionOwner && (
          <Box width={["100%", 200]} pt={16}>
            <FlexibleButton
              as={Link}
              to={buildScenarioUrl({
                roleplaySlug,
                scenarioSlug: scenario?.slug || "",
              })}
              icon={<Icon icon="reset" />}
              variant="primary"
              fill={true}
            >
              Retry
            </FlexibleButton>
          </Box>
        )}
      </Flex>
    </CardAboveXs>
  );
}
